module.exports = __webpack_public_path__ + "static/img/img_p2_4_pic.6d099b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_p2_4_pic.png
// module id = GFhV
// module chunks = 1